import './App.css';
import { useState, useEffect } from 'react';
import QuoteModal from './QuoteModal';
import { HeroCanvas, LogoCanvas } from './HeroScene';
import { useScrollReveal } from './useScrollReveal';

function App() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Scroll-reveal observer (legacy classes)
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll('.reveal, .heading-reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  useScrollReveal('[data-reveal]');
  return (
    <div className="bg-white">
      {/* Header */}
      <header id="header" className="bg-white/95 backdrop-blur-sm border-b border-blue-100 sticky top-0 z-50 shadow-sm" style={isMobile ? {
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(4px)',
        borderBottom: '1px solid #dbeafe',
        position: 'sticky',
        top: '0',
        zIndex: '50',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
      } : {}}>
        <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" style={isMobile ? {
          maxWidth: '80rem',
          margin: '0 auto',
          paddingLeft: '0.75rem',
          paddingRight: '0.75rem'
        } : {}}>
          <div className="flex justify-between items-center h-14 sm:h-16 gap-2" style={isMobile ? {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            height: '3.5rem',
            gap: '0.5rem'
          } : {}}>
            <div className="flex items-center" style={isMobile ? { display: 'flex', alignItems: 'center' } : {}}>
              <img 
                src="/logpeg.jpg" 
                alt="TechnoOption Logo" 
                className="h-8 sm:h-10 md:h-12 w-auto cursor-pointer"
                style={isMobile ? {
                  height: '2rem',
                  width: 'auto',
                  cursor: 'pointer',
                  maxHeight: '2rem'
                } : {}}
              />
            </div>
            
            <nav className="hidden md:flex space-x-6 lg:space-x-8">
              <span className="text-slate-700 hover:text-blue-600 cursor-pointer font-medium transition-colors whitespace-nowrap"  onClick={() => document.getElementById('servicios').scrollIntoView({ behavior: 'smooth' })}>Servicios</span>
              <span className="text-slate-700 hover:text-blue-600 cursor-pointer font-medium transition-colors whitespace-nowrap"  onClick={() => document.getElementById('portafolio').scrollIntoView({ behavior: 'smooth' })}>Portafolio</span>
              <span className="text-slate-700 hover:text-blue-600 cursor-pointer font-medium transition-colors whitespace-nowrap"  onClick={() => document.getElementById('diferenciadores').scrollIntoView({ behavior: 'smooth' })}>Acerca</span>
            </nav>
            
            <div className="flex items-center space-x-2 sm:space-x-4">
              <div className="hidden md:flex items-center space-x-3">
                <a 
                  href="https://www.facebook.com/profile.php?id=61574581873897" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-slate-600 hover:text-blue-600 transition-colors cursor-pointer"
                >
                  <i className="fa-brands fa-facebook text-lg"></i>
                </a>
                <a 
                  href="https://www.instagram.com/teamtechnooption?igsh=MTU1YjRoYzl6c3hvdg==" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-slate-600 hover:text-pink-600 transition-colors cursor-pointer"
                >
                  <i className="fa-brands fa-instagram text-lg"></i>
                </a>
                <a 
                  href="https://wa.me/50230446042" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-slate-600 hover:text-green-600 transition-colors cursor-pointer"
                >
                  <i className="fa-brands fa-whatsapp text-lg"></i>
                </a>
                <a 
                  href="https://www.linkedin.com/company/technooption/about/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-slate-600 hover:text-blue-600 transition-colors cursor-pointer"
                >
                  <i className="fa-brands fa-linkedin text-lg"></i>
                </a>
                <a 
                  href="https://www.tiktok.com/@technooption?_t=ZM-90M5wjPaDHM&_r=1" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-slate-600 hover:text-pink-600 transition-colors cursor-pointer"
                >
                  <i className="fa-brands fa-tiktok text-lg"></i>
                </a>
              </div>
              <button 
                onClick={() => setIsQuoteModalOpen(true)}
                className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 sm:px-6 py-2 rounded-xl hover:shadow-lg transform hover:scale-105 transition-all duration-200 font-semibold text-sm sm:text-base"
                style={isMobile ? {
                  background: 'linear-gradient(to right, #2563eb, #9333ea)',
                  color: 'white',
                  padding: '0.5rem 1rem',
                  borderRadius: '0.75rem',
                  border: 'none',
                  fontWeight: '600',
                  fontSize: '0.875rem',
                  cursor: 'pointer',
                  minHeight: '40px',
                  whiteSpace: 'nowrap'
                } : {
                  background: 'linear-gradient(to right, #2563eb, #9333ea)',
                  color: 'white',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '0.75rem',
                  border: 'none',
                  fontWeight: '600',
                  fontSize: '1rem',
                  cursor: 'pointer',
                  minHeight: '44px',
                  whiteSpace: 'nowrap'
                }}
              >
                Hablemos
              </button>
              <button 
                className="block md:hidden p-2 min-h-[44px] min-w-[44px] items-center justify-center"
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                style={{
                  display: isMobile ? 'flex' : 'none',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '0.5rem',
                  minHeight: '44px',
                  minWidth: '44px',
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer'
                }}
              >
                <i className="fa-solid fa-bars text-slate-700 text-xl" style={{
                  color: '#475569',
                  fontSize: '1.25rem'
                }}></i>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && isMobile && (
        <div className="md:hidden bg-white border-b border-blue-100 shadow-lg">
          <div className="px-4 py-4 space-y-2">
            <div className="flex items-center justify-between py-3 px-2 rounded-lg hover:bg-slate-50 transition-colors">
              <span 
                className="text-slate-700 hover:text-blue-600 cursor-pointer font-medium transition-colors text-base"
                onClick={() => {
                  document.getElementById('servicios').scrollIntoView({ behavior: 'smooth' });
                  setIsMobileMenuOpen(false);
                }}
              >
                Servicios
              </span>
            </div>
            <div className="flex items-center justify-between py-3 px-2 rounded-lg hover:bg-slate-50 transition-colors">
              <span 
                className="text-slate-700 hover:text-blue-600 cursor-pointer font-medium transition-colors text-base"
                onClick={() => {
                  document.getElementById('portafolio').scrollIntoView({ behavior: 'smooth' });
                  setIsMobileMenuOpen(false);
                }}
              >
                Portafolio
              </span>
            </div>
            <div className="flex items-center justify-between py-3 px-2 rounded-lg hover:bg-slate-50 transition-colors">
              <span 
                className="text-slate-700 hover:text-blue-600 cursor-pointer font-medium transition-colors text-base"
                onClick={() => {
                  document.getElementById('diferenciadores').scrollIntoView({ behavior: 'smooth' });
                  setIsMobileMenuOpen(false);
                }}
              >
                Acerca
              </span>
            </div>
            <div className="pt-4 border-t border-slate-200">
              <div className="flex items-center justify-center space-x-6 mb-4">
                <a 
                  href="https://www.facebook.com/profile.php?id=61574581873897" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-slate-600 hover:text-blue-600 transition-colors cursor-pointer p-2 min-h-[44px] min-w-[44px] flex items-center justify-center"
                >
                  <i className="fa-brands fa-facebook text-xl"></i>
                </a>
                <a 
                  href="https://www.instagram.com/teamtechnooption?igsh=MTU1YjRoYzl6c3hvdg==" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-slate-600 hover:text-pink-600 transition-colors cursor-pointer p-2 min-h-[44px] min-w-[44px] flex items-center justify-center"
                >
                  <i className="fa-brands fa-instagram text-xl"></i>
                </a>
                <a 
                  href="https://wa.me/50230446042" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-slate-600 hover:text-green-600 transition-colors cursor-pointer p-2 min-h-[44px] min-w-[44px] flex items-center justify-center"
                >
                  <i className="fa-brands fa-whatsapp text-xl"></i>
                </a>
                <a 
                  href="https://www.linkedin.com/company/technooption/about/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-slate-600 hover:text-blue-600 transition-colors cursor-pointer p-2 min-h-[44px] min-w-[44px] flex items-center justify-center"
                >
                  <i className="fa-brands fa-linkedin text-xl"></i>
                </a>
                <a 
                  href="https://www.tiktok.com/@technooption?_t=ZM-90M5wjPaDHM&_r=1" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-slate-600 hover:text-pink-600 transition-colors cursor-pointer p-2 min-h-[44px] min-w-[44px] flex items-center justify-center"
                >
                  <i className="fa-brands fa-tiktok text-xl"></i>
                </a>
              </div>
              <button 
                onClick={() => {
                  setIsQuoteModalOpen(true);
                  setIsMobileMenuOpen(false);
                }}
                className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-3 rounded-xl hover:shadow-lg transform hover:scale-105 transition-all duration-200 font-semibold min-h-[44px]"
              >
                Hablemos
              </button>
            </div>
          </div>
        </div>
      )}

      <main>
        {/* Hero Section */}
        <section id="hero" className="relative min-h-screen flex items-center overflow-hidden" style={{
          background: 'linear-gradient(135deg, #0f0c29 0%, #141432 40%, #0d1b4b 70%, #0a0a2e 100%)',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden',
          position: 'relative'
        }}>
          {/* Three.js animated background */}
          <HeroCanvas />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative w-full py-8 sm:py-12" style={isMobile ? {
            maxWidth: '80rem',
            margin: '0 auto',
            paddingLeft: '1rem',
            paddingRight: '1rem',
            position: 'relative',
            width: '100%',
            paddingTop: '2rem',
            paddingBottom: '2rem'
          } : {}}>
            <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
              <div className="space-y-6 sm:space-y-8 text-center lg:text-left">
                <div className="space-y-4 sm:space-y-6 hero-fade-up">
                  <h1 style={isMobile ? {
                    fontSize: '2rem',
                    fontWeight: '900',
                    color: '#ffffff',
                    lineHeight: '1.1',
                    marginBottom: '1.5rem'
                  } : {
                    fontSize: '4.5rem',
                    fontWeight: '900',
                    color: '#ffffff',
                    lineHeight: '1.1',
                    marginBottom: '1.5rem'
                  }}>
                    Transformamos ideas en
                    <span style={{
                      background: 'linear-gradient(90deg, #a5b4fc, #93c5fd)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text',
                      display: 'block',
                      marginTop: '0.25rem',
                      filter: 'drop-shadow(0 0 20px rgba(165,180,252,0.4))'
                    }}> soluciones digitales</span>
                  </h1>
                  <p style={isMobile ? {
                    fontSize: '0.875rem',
                    color: '#94a3b8',
                    lineHeight: '1.6',
                    maxWidth: '42rem',
                    margin: '0 auto',
                    paddingLeft: '0.5rem',
                    paddingRight: '0.5rem',
                    marginBottom: '2rem'
                  } : {
                    fontSize: '1.25rem',
                    color: '#94a3b8',
                    lineHeight: '1.6',
                    maxWidth: '42rem',
                    margin: '0 auto',
                    paddingLeft: '0.5rem',
                    paddingRight: '0.5rem',
                    marginBottom: '2rem'
                  }}>
                    Desarrollamos sitios web, plataformas de e-commerce y software personalizado que impulsan el crecimiento de tu negocio.
                  </p>
                </div>
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center lg:justify-start px-4 sm:px-0 hero-fade-up-delay-2">
                  <button 
                    onClick={() => setIsQuoteModalOpen(true)}
                    className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl hover:shadow-xl transform hover:scale-105 transition-all duration-200 font-semibold text-base w-full sm:w-auto min-h-[44px]"
                    style={isMobile ? {
                      background: 'linear-gradient(to right, #2563eb, #9333ea)',
                      color: 'white',
                      padding: '0.75rem 1.5rem',
                      borderRadius: '0.75rem',
                      border: 'none',
                      fontWeight: '600',
                      fontSize: '1rem',
                      cursor: 'pointer',
                      width: '100%',
                      minHeight: '44px',
                      marginBottom: '0.75rem'
                    } : {
                      background: 'linear-gradient(to right, #2563eb, #9333ea)',
                      color: 'white',
                      padding: '1rem 2rem',
                      borderRadius: '0.75rem',
                      border: 'none',
                      fontWeight: '600',
                      fontSize: '1.125rem',
                      cursor: 'pointer',
                      minHeight: '48px'
                    }}
                  >
                    Solicita una cotización
                  </button>
                  <button 
                    onClick={() => document.getElementById('portafolio').scrollIntoView({ behavior: 'smooth' })}
                    className="border-2 border-slate-300 text-slate-700 px-6 sm:px-8 py-3 sm:py-4 rounded-xl hover:bg-slate-50 hover:border-blue-300 transition-all duration-200 font-semibold text-base w-full sm:w-auto min-h-[44px]"
                    style={isMobile ? {
                      border: '2px solid #cbd5e1',
                      color: '#334155',
                      background: 'white',
                      padding: '0.75rem 1.5rem',
                      borderRadius: '0.75rem',
                      fontWeight: '600',
                      fontSize: '1rem',
                      cursor: 'pointer',
                      width: '100%',
                      minHeight: '44px'
                    } : {
                      border: '2px solid #cbd5e1',
                      color: '#334155',
                      background: 'white',
                      padding: '1rem 2rem',
                      borderRadius: '0.75rem',
                      fontWeight: '600',
                      fontSize: '1.125rem',
                      cursor: 'pointer',
                      minHeight: '48px'
                    }}
                  >
                    Ver portafolio
                  </button>
                </div>
              </div>
              <div className="relative order-first lg:order-last hero-card-in" style={{
                height: isMobile ? '260px' : '420px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <div style={{
                  width: '100%',
                  height: '100%',
                  borderRadius: '1.5rem',
                  overflow: 'hidden',
                  background: 'rgba(99,102,241,0.05)',
                  border: '1px solid rgba(99,102,241,0.2)',
                  boxShadow: '0 0 60px rgba(99,102,241,0.15), 0 0 120px rgba(96,165,250,0.08)'
                }}>
                  <LogoCanvas />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Trust Section */}
        <section id="trust" className="bg-white py-16 border-b border-slate-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12 reveal">
              <h2 className="text-2xl font-bold text-slate-900 mb-2">Soluciones que impulsan tu negocio</h2>
              <p className="text-slate-600">Digitalizando tus ideas</p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center">
              <div className="bg-slate-50 h-20 rounded-xl flex items-center justify-center shadow-sm border border-slate-200/80 reveal stagger-1">
                <span className="text-slate-600 font-semibold tracking-wider">Sitios Web</span>
              </div>
              <div className="bg-slate-50 h-20 rounded-xl flex items-center justify-center shadow-sm border border-slate-200/80 reveal stagger-2">
                <span className="text-slate-600 font-semibold tracking-wider">Apps Mobiles</span>
              </div>
              <div className="bg-slate-50 h-20 rounded-xl flex items-center justify-center shadow-sm border border-slate-200/80 reveal stagger-3">
                <span className="text-slate-600 font-semibold tracking-wider">100% Responsive</span>
              </div>
              <div className="bg-slate-50 h-20 rounded-xl flex items-center justify-center shadow-sm border border-slate-200/80 reveal stagger-4">
                <span className="text-slate-600 font-semibold tracking-wider">Ecommerce</span>
              </div>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section id="servicios" className="bg-gradient-to-br from-slate-50 to-white py-12 sm:py-16 lg:py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12 sm:mb-16 space-y-4 reveal">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 heading-reveal">Nuestros Servicios</h2>
              <p className="text-lg sm:text-xl text-slate-600">Soluciones digitales adaptadas a tus necesidades</p>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              <div className="service-card bg-white border-2 border-blue-100 rounded-3xl p-6 sm:p-8 hover:shadow-2xl hover:border-blue-200 transition-all duration-300 reveal stagger-1">
                <div className="bg-gradient-to-br from-blue-500 to-blue-600 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                  <i className="fa-solid fa-globe text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">Sitios Informativos</h3>
                <p className="text-slate-600 mb-6 leading-relaxed">Presencia digital profesional que genera confianza y convierte visitantes en clientes.</p>
                <ul className="space-y-3 mb-6">
                  <li className="flex items-center text-slate-700">
                    <i className="fa-solid fa-check text-blue-600 mr-3"></i>
                    <span className="font-medium">Diseño responsive</span>
                  </li>
                  <li className="flex items-center text-slate-700">
                    <i className="fa-solid fa-check text-blue-600 mr-3"></i>
                    <span className="font-medium">SEO optimizado</span>
                  </li>
                  <li className="flex items-center text-slate-700">
                    <i className="fa-solid fa-check text-blue-600 mr-3"></i>
                    <span className="font-medium">Carga rápida</span>
                  </li>
                </ul>
                <button className="text-blue-600 hover:text-blue-700 font-semibold flex items-center group"  onClick={() => setIsQuoteModalOpen(true)}>
                  Hablemos <i className="fa-solid fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform"></i>
                </button>
              </div>

              <div className="service-card bg-white border-2 border-purple-100 rounded-3xl p-6 sm:p-8 hover:shadow-2xl hover:border-purple-200 transition-all duration-300 reveal stagger-2">
                <div className="bg-gradient-to-br from-purple-500 to-purple-600 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                  <i className="fa-solid fa-shopping-cart text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">E-commerce</h3>
                <p className="text-slate-600 mb-6 leading-relaxed">Tiendas online completas que maximizan tus ventas y optimizan la experiencia del cliente.</p>
                <ul className="space-y-3 mb-6">
                  <li className="flex items-center text-slate-700">
                    <i className="fa-solid fa-check text-purple-600 mr-3"></i>
                    <span className="font-medium">Gestión de inventario</span>
                  </li>
                  <li className="flex items-center text-slate-700">
                    <i className="fa-solid fa-check text-purple-600 mr-3"></i>
                    <span className="font-medium">Pagos seguros</span>
                  </li>
                  <li className="flex items-center text-slate-700">
                    <i className="fa-solid fa-check text-purple-600 mr-3"></i>
                    <span className="font-medium">Panel administrativo</span>
                  </li>
                </ul>
                <button className="text-purple-600 hover:text-purple-700 font-semibold flex items-center group"  onClick={() => setIsQuoteModalOpen(true)}>
                  Hablemos <i className="fa-solid fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform"></i>
                </button>
              </div>

              <div className="service-card bg-white border-2 border-slate-200 rounded-3xl p-6 sm:p-8 hover:shadow-2xl hover:border-slate-300 transition-all duration-300 reveal stagger-3">
                <div className="bg-gradient-to-br from-slate-600 to-slate-700 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                  <i className="fa-solid fa-code text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">Software a la Medida</h3>
                <p className="text-slate-600 mb-6 leading-relaxed">Aplicaciones personalizadas que automatizan procesos y resuelven desafíos específicos.</p>
                <ul className="space-y-3 mb-6">
                  <li className="flex items-center text-slate-700">
                    <i className="fa-solid fa-check text-slate-600 mr-3"></i>
                    <span className="font-medium">Desarrollo personalizado</span>
                  </li>
                  <li className="flex items-center text-slate-700">
                    <i className="fa-solid fa-check text-slate-600 mr-3"></i>
                    <span className="font-medium">Integración de sistemas</span>
                  </li>
                  <li className="flex items-center text-slate-700">
                    <i className="fa-solid fa-check text-slate-600 mr-3"></i>
                    <span className="font-medium">Escalabilidad garantizada</span>
                  </li>
                </ul>
                <button className="text-slate-600 hover:text-slate-700 font-semibold flex items-center group"  onClick={() => setIsQuoteModalOpen(true)}>
                  Hablemos <i className="fa-solid fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform"></i>
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Us Section */}
        <section id="diferenciadores" className="bg-white py-12 sm:py-16 lg:py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12 sm:mb-16 space-y-4 reveal">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 heading-reveal">¿Por qué elegirnos?</h2>
              <p className="text-lg sm:text-xl text-slate-600">Los pilares de nuestro éxito</p>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
              <div className="text-center group reveal stagger-1">
                <div className="bg-gradient-to-br from-blue-500 to-blue-600 w-20 h-20 rounded-3xl flex items-center justify-center mx-auto mb-6 shadow-xl group-hover:scale-110 transition-transform duration-300">
                  <i className="fa-solid fa-headset text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">Soporte 24/7</h3>
                <p className="text-slate-600 leading-relaxed">Asistencia técnica continua para mantener tu proyecto funcionando perfectamente.</p>
              </div>

              <div className="text-center group reveal stagger-2">
                <div className="bg-gradient-to-br from-purple-500 to-purple-600 w-20 h-20 rounded-3xl flex items-center justify-center mx-auto mb-6 shadow-xl group-hover:scale-110 transition-transform duration-300">
                  <i className="fa-solid fa-chart-line text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">Escalabilidad</h3>
                <p className="text-slate-600 leading-relaxed">Soluciones diseñadas para crecer junto con tu negocio sin limitaciones.</p>
              </div>

              <div className="text-center group reveal stagger-3">
                <div className="bg-gradient-to-br from-emerald-500 to-emerald-600 w-20 h-20 rounded-3xl flex items-center justify-center mx-auto mb-6 shadow-xl group-hover:scale-110 transition-transform duration-300">
                  <i className="fa-solid fa-users text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">Enfoque al Cliente</h3>
                <p className="text-slate-600 leading-relaxed">Trabajamos de cerca contigo para entender y superar tus expectativas.</p>
              </div>

              <div className="text-center group reveal stagger-4">
                <div className="bg-gradient-to-br from-amber-500 to-amber-600 w-20 h-20 rounded-3xl flex items-center justify-center mx-auto mb-6 shadow-xl group-hover:scale-110 transition-transform duration-300">
                  <i className="fa-solid fa-award text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">Calidad Premium</h3>
                <p className="text-slate-600 leading-relaxed">Código limpio, diseño excepcional y mejores prácticas en cada proyecto.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Portfolio Section */}
        <section id="portafolio" className="bg-gradient-to-br from-slate-50 to-white py-12 sm:py-16 lg:py-20" >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12 sm:mb-16 space-y-4 reveal">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 heading-reveal">Nuestras Soluciones</h2>
              <p className="text-lg sm:text-xl text-slate-600">Proyectos que transformaran tus negocios</p>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 max-w-7xl mx-auto">
              <div className="bg-white border border-slate-200 rounded-3xl overflow-hidden hover:shadow-2xl transition-all duration-300 group w-full reveal stagger-1">
                <div className="h-48 relative overflow-hidden">
                  <div className="w-full h-full bg-gradient-to-br from-purple-500 to-pink-600 flex items-center justify-center">
                    <div className="text-center text-white">
                      <i className="fa-solid fa-cash-register text-4xl mb-2"></i>
                      <p className="text-sm font-medium">Ya disponible!!!</p>
                    </div>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                </div>
                <div className="p-6 space-y-4">
                  <h3 className="text-xl font-bold text-slate-900">Punto de Ventas</h3>
                  <p className="text-slate-600">Genera Facturas, controla tus inventarios y flujo</p>
                </div>
              </div>

              <div className="bg-white border border-slate-200 rounded-3xl overflow-hidden hover:shadow-2xl transition-all duration-300 group w-full reveal stagger-2">
                <div className="h-48 relative overflow-hidden">
                  <div className="w-full h-full bg-gradient-to-br from-purple-500 to-pink-600 flex items-center justify-center">
                    <div className="text-center text-white">
                      <i className="fa-solid fa-mobile-screen-button text-4xl mb-2"></i>
                      <p className="text-sm font-medium">Ya disponible!!!</p>
                    </div>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                </div>
                <div className="p-6 space-y-4">
                  <h3 className="text-xl font-bold text-slate-900">Control de Clientes y Servicios</h3>
                  <p className="text-slate-600">Permite un acceso centralizado de toda la información necesaria para el manejo de clientes y servicios.</p>
                </div>
              </div>

              <div className="bg-white border border-slate-200 rounded-3xl overflow-hidden hover:shadow-2xl transition-all duration-300 group w-full sm:col-span-2 sm:max-w-md sm:mx-auto lg:col-span-1 lg:max-w-none reveal stagger-3">
                <div className="h-48 relative overflow-hidden">
                  <div className="w-full h-full bg-gradient-to-br from-amber-500 via-orange-500 to-rose-600 flex items-center justify-center">
                    <div className="text-center text-white drop-shadow-md">
                      <i className="fa-solid fa-graduation-cap text-4xl mb-2"></i>
                      <p className="text-sm font-semibold">Ya disponible!!!</p>
                    </div>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/15 to-transparent"></div>
                </div>
                <div className="p-6 space-y-4">
                  <h3 className="text-xl font-bold text-slate-900">Control Academico</h3>
                  <p className="text-slate-600">Automatiza la planilficacion docente y el control de notas de forma sencilla!</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Quote Modal */}
      <QuoteModal 
        isOpen={isQuoteModalOpen} 
        onClose={() => setIsQuoteModalOpen(false)} 
      />
    </div>
  );
}

export default App;
